export const buildHighlighterProps = (componentClass: string, radiusClass: string, isActive: boolean) => {
  const attrValue = isActive ? `${componentClass}-active-highlight ${radiusClass}` : componentClass;
  return {className: attrValue};
};
